import React from 'react';
import PropTypes from 'prop-types';
import {Bar} from "react-chartjs-2";
import {useIntl} from "react-intl";
import moment from "moment";
import {blueColor, greyishBlue100, greyishBlue500} from "assets/jss/main";

ShippedHistoryChart.propTypes = {
    rows: PropTypes.array.isRequired
};

function ShippedHistoryChart({rows}) {
    const intl = useIntl()

    const data = {
        labels: rows.map(row => moment(row.day).format('D/MM')),
        datasets: [{
            label: intl.formatMessage({id: 'wms.admin_wms_stats.flow.shipped'}),
            data: rows.map(row => row.total),
            backgroundColor: blueColor,
            borderWidth: 0,
            barPercentage: 0.7,
            categoryPercentage: 0.8
        }]
    }

    const options = {
        maintainAspectRatio: false,
        legend: {display: false},
        tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
                title: items => moment(rows[items[0].index].day).format('dddd D MMMM')
            }
        },
        scales: {
            xAxes: [{
                gridLines: {display: false},
                ticks: {fontColor: greyishBlue500, autoSkip: true, maxTicksLimit: 15, maxRotation: 0}
            }],
            yAxes: [{
                ticks: {beginAtZero: true, precision: 0, fontColor: greyishBlue500},
                gridLines: {color: greyishBlue100, drawBorder: false}
            }]
        }
    }

    return (
        <div style={{height: "220px"}}>
            <Bar data={data} options={options}/>
        </div>
    );
}

export default ShippedHistoryChart;
